import styled from 'styled-components'
import { Row as GridRow } from 'react-grid-system'
import { BREAK_POINTS } from '@/utils/constants'

export const Content = styled.div`
  width: 90%;
`

export const Label = styled.div`
  margin-bottom: 10px;
  white-space: nowrap;
  @media (max-width: ${BREAK_POINTS.md}) {
    margin-top: 16px;
  }
`

export const Row = styled(GridRow)`
  margin-top: 32px;
  @media (max-width: ${BREAK_POINTS.md}) {
    margin-top: 0px;
  }
`

export const Spacing = styled.div`
  margin-top: 32px;
`

export const Fieldset = styled.fieldset`
  border: none;
`
